import 'core-js/stable';
import 'regenerator-runtime/runtime';
import TagManager from './TagManager';
import ECommerce from './ECommerce';

export {
  TagManager,
  ECommerce,
};
